import Fragment from "../../football/fragments/fragment";
import FragmentDataType from "../../football/enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";
import FragmentSummary from "../../football/fragments/fragment-summary";

export default class FlagRun extends Fragment {
    constructor(runBy) {
        super();

        this.patType = "R";
        this.runBy = runBy;

        this.requiredData = [
            {
                name: "runBy",
                type: FragmentDataType.Player,
                displayName: "Rushed by",
                title: (team) => `Rushed By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    getFragmentTeamId() {
        return this.runBy?.teamId;
    }

    getPlayers() {
        return [this.runBy];
    }

    summarize(summaryContext, stringifier) {
        const message = `${stringifier.firstInitial(this.runBy)} ${
            summaryContext.patPoints
        }-point rush attempt`;
        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            runBy: playerReducer(this.runBy)
        };
    }
}
